import { useContext, useEffect, useState } from "react";
import { has, isEmpty } from "lodash";
import Joi from "joi";

import InputField from "../form/InputField";
import { ButtonDefault } from "../Buttons";

import { validateProperty } from "../../utils/validation";

import ApplicationPreview from "../ApplicationPreview";
import AppContext from "../../Context/AppContext";

import application from "../../data/application.json";

const Applicant1CurrentAddressForm = () => {
  const { applicationData, setApplicationData, modal, setModal } =
    useContext(AppContext);

  const [data, setData] = useState({});
  const [formDataChange, setFormDataChange] = useState({});
  //const [errors, setErrors] = useState({});

  useEffect(() => {
    const { applicant1CurrentAddress } = { ...applicationData };

    const currentAddress =
      has(applicant1CurrentAddress, "currentAddress") &&
      applicant1CurrentAddress.currentAddress !== null
        ? applicant1CurrentAddress.currentAddress
        : null;

    const moveInDate =
      has(applicant1CurrentAddress, "moveInDate") &&
      applicant1CurrentAddress.moveInDate
        ? applicant1CurrentAddress.moveInDate
        : null;

    setData({
      currentAddress,
      moveInDate,
    });
  }, []);

  //   useEffect(() => {
  //     // VALIDATE PROPERTY
  //     if (!isEmpty(formDataChange))
  //       validateProperty(formDataChange, schemaObj, errors, setErrors);
  //   }, [formDataChange]);

  //   const schemaObj = {
  //     email: Joi.string().email({ tlds: false }).allow(null, "").messages({
  //       "string.email": "Please enter a valid email address",
  //     }),
  //     phone: Joi.string().allow(null, ""),
  //   };

  const handleChange = ({ currentTarget }) => {
    const input = {
      name: currentTarget.name,
      value: currentTarget.value,
    };
    doAfterChange(input);
  };

  const doAfterChange = (input) => {
    setData({
      ...data,
      [input.name]: input.value,
    });
    setFormDataChange(input);
  };

  const handleSave = () => {
    handleModalClose();
    setApplicationData({
      ...applicationData,
      applicant1CurrentAddress: data,
    });
  };

  const handleModalClose = () => {
    modal.modalOpenedFrom === "preview"
      ? setModal({
          modalOpen: true,
          modalType: "preview",
          modalTitle: "Preview application",
          modalContent: <ApplicationPreview />,
        })
      : setModal({ modalOpen: false });
  };

  const { formFields } =
    application.cards.details.forms.applicant1CurrentAddress;

  return (
    <div className="rounded-lg bg-white p-8 text-center text-black">
      <p className="mb-4 text-4xl">{modal.modalTitle}</p>
      <div className="mb-4 flex justify-center">
        <div className="w-full max-w-sm ">
          <InputField
            name="currentAddress"
            label={formFields.currentAddress.label}
            type="text"
            help={null}
            value={data.currentAddress}
            onChange={handleChange}
            // error={errors.currentAddress}
          />
        </div>
      </div>
      <div className="mb-4 flex justify-center">
        <div className="w-full max-w-sm ">
          <InputField
            name="moveInDate"
            label={formFields.moveInDate.label}
            type="text"
            help={null}
            value={data.moveInDate}
            onChange={handleChange}
            // error={errors.moveInDate}
          />
        </div>
      </div>
      <div className="flex justify-center pt-4">
        <div className="w-full max-w-sm ">
          <div className="flex items-center">
            <span className="mr-4">
              <ButtonDefault
                color="emerald"
                label="Save"
                onClick={handleSave}
              />
            </span>

            <ButtonDefault
              color="white"
              label="Cancel"
              onClick={handleModalClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Applicant1CurrentAddressForm;
